export default {
  BAD_USER_INPUT: 'Verifique os dados informados e tente novamente.',
  INSUFFICIENT_STOCK: 'Estoque indisponível.',
  RESOURCE_NOT_FOUND: 'Entrega indisponível para este CEP.',
  SOMETHING_WRONG: 'Não foi possível calcular o frete. Tente novamente.',
  UNPROCESSABLE_ENTITY: 'Não foi possível processar a entrega.'
};